/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EscalationRecord } from './EscalationRecord';
import {
    EscalationRecordFromJSON,
    EscalationRecordFromJSONTyped,
    EscalationRecordToJSON,
    EscalationRecordToJSONTyped,
} from './EscalationRecord';

/**
 * 
 * @export
 * @interface VulnerabilityOwnership
 */
export interface VulnerabilityOwnership {
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityOwnership
     */
    remediationOwner?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityOwnership
     */
    remediationOwnerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityOwnership
     */
    remediationOwnerType?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityOwnership
     */
    securityTeam?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityOwnership
     */
    securityTeamEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityOwnership
     */
    complianceTeam?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityOwnership
     */
    complianceTeamEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityOwnership
     */
    assignmentSource?: string;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityOwnership
     */
    assignmentRule?: string;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityOwnership
     */
    assignmentLastUpdated?: Date;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityOwnership
     */
    assignmentLastUpdatedBy?: string;
    /**
     * 
     * @type {Array<EscalationRecord>}
     * @memberof VulnerabilityOwnership
     */
    escalationHistory?: Array<EscalationRecord>;
    /**
     * 
     * @type {string}
     * @memberof VulnerabilityOwnership
     */
    delegatedTo?: string;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityOwnership
     */
    delegatedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof VulnerabilityOwnership
     */
    delegationExpiresAt?: Date;
}

/**
 * Check if a given object implements the VulnerabilityOwnership interface.
 */
export function instanceOfVulnerabilityOwnership(value: object): value is VulnerabilityOwnership {
    return true;
}

export function VulnerabilityOwnershipFromJSON(json: any): VulnerabilityOwnership {
    return VulnerabilityOwnershipFromJSONTyped(json, false);
}

export function VulnerabilityOwnershipFromJSONTyped(json: any, ignoreDiscriminator: boolean): VulnerabilityOwnership {
    if (json == null) {
        return json;
    }
    return {
        
        'remediationOwner': json['remediationOwner'] == null ? undefined : json['remediationOwner'],
        'remediationOwnerEmail': json['remediationOwnerEmail'] == null ? undefined : json['remediationOwnerEmail'],
        'remediationOwnerType': json['remediationOwnerType'] == null ? undefined : json['remediationOwnerType'],
        'securityTeam': json['securityTeam'] == null ? undefined : json['securityTeam'],
        'securityTeamEmail': json['securityTeamEmail'] == null ? undefined : json['securityTeamEmail'],
        'complianceTeam': json['complianceTeam'] == null ? undefined : json['complianceTeam'],
        'complianceTeamEmail': json['complianceTeamEmail'] == null ? undefined : json['complianceTeamEmail'],
        'assignmentSource': json['assignmentSource'] == null ? undefined : json['assignmentSource'],
        'assignmentRule': json['assignmentRule'] == null ? undefined : json['assignmentRule'],
        'assignmentLastUpdated': json['assignmentLastUpdated'] == null ? undefined : (new Date(json['assignmentLastUpdated'])),
        'assignmentLastUpdatedBy': json['assignmentLastUpdatedBy'] == null ? undefined : json['assignmentLastUpdatedBy'],
        'escalationHistory': json['escalationHistory'] == null ? undefined : ((json['escalationHistory'] as Array<any>).map(EscalationRecordFromJSON)),
        'delegatedTo': json['delegatedTo'] == null ? undefined : json['delegatedTo'],
        'delegatedAt': json['delegatedAt'] == null ? undefined : (new Date(json['delegatedAt'])),
        'delegationExpiresAt': json['delegationExpiresAt'] == null ? undefined : (new Date(json['delegationExpiresAt'])),
    };
}

export function VulnerabilityOwnershipToJSON(json: any): VulnerabilityOwnership {
    return VulnerabilityOwnershipToJSONTyped(json, false);
}

export function VulnerabilityOwnershipToJSONTyped(value?: VulnerabilityOwnership | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'remediationOwner': value['remediationOwner'],
        'remediationOwnerEmail': value['remediationOwnerEmail'],
        'remediationOwnerType': value['remediationOwnerType'],
        'securityTeam': value['securityTeam'],
        'securityTeamEmail': value['securityTeamEmail'],
        'complianceTeam': value['complianceTeam'],
        'complianceTeamEmail': value['complianceTeamEmail'],
        'assignmentSource': value['assignmentSource'],
        'assignmentRule': value['assignmentRule'],
        'assignmentLastUpdated': value['assignmentLastUpdated'] == null ? undefined : ((value['assignmentLastUpdated']).toISOString()),
        'assignmentLastUpdatedBy': value['assignmentLastUpdatedBy'],
        'escalationHistory': value['escalationHistory'] == null ? undefined : ((value['escalationHistory'] as Array<any>).map(EscalationRecordToJSON)),
        'delegatedTo': value['delegatedTo'],
        'delegatedAt': value['delegatedAt'] == null ? undefined : ((value['delegatedAt']).toISOString()),
        'delegationExpiresAt': value['delegationExpiresAt'] == null ? undefined : ((value['delegationExpiresAt']).toISOString()),
    };
}

